import { type IOrderRepository } from '@webapp/modules/purchasing/business-logic/interfaces/IOrderRepository'

export class CheckHasOrderWatchlistUseCase {
  constructor(
    private readonly deps: {
      orderRepository: Pick<IOrderRepository, 'listWatchlistApprovers'>
    }
  ) {}

  execute = async (): Promise<boolean> => {
    try {
      const result = await this.deps.orderRepository.listWatchlistApprovers({
        page: 1,
        pageSize: 1,
      })

      return result.pagination.count > 0
    } catch {
      // Sanctioned silent degradation — overrides the ADR-10
      // toast default. Angular parity: a failed probe hides the "Viewing
      // as" select, console-only.
      return false
    }
  }
}
